class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'shopify_recently_viewed_cards';
    this.sectionId = this.dataset.sectionId;
    this.maxProducts = parseInt(this.dataset.limit) || 10;
    this.currentProductId = this.dataset.productId;
    this.maxColumnsToShow = parseInt(this.dataset.maxColumnsToShow) || 4;

    const sectionTemplateEl = document.getElementById('recently-viewed-section-template');
    this.sectionTemplate = sectionTemplateEl ? sectionTemplateEl.textContent : '';
  }

  connectedCallback() {
    this.saveCurrentProductCard();
    this.loadRecentlyViewedProducts();
  }

  saveCurrentProductCard() {
    if (!this.currentProductId) return;

    // Get the current product card template
    const cardTemplateEl = document.getElementById(`current-product-card-${this.sectionId}`);
    if (!cardTemplateEl) return;

    let cardHTML = cardTemplateEl.textContent;
    
    // Replace {index} with 1 for storage
    cardHTML = cardHTML.replace(/{index}/g, '1');

    // Get existing cards from storage
    let recentCards = this.getRecentlyViewed();
    
    // Create card object with ID and HTML
    const cardData = {
      id: this.currentProductId,
      html: cardHTML
    };
    
    // Remove this product if it already exists
    recentCards = recentCards.filter(card => card.id !== this.currentProductId);
    
    // Add to beginning
    recentCards.unshift(cardData);
    
    // Limit to max products
    recentCards = recentCards.slice(0, this.maxProducts);
    
    // Save to localStorage
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(recentCards));
    } catch (e) {
      console.error('Error saving to localStorage:', e);
    }
  }

  getRecentlyViewed() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  }

  loadRecentlyViewedProducts() {
    let cards = this.getRecentlyViewed();
    
    // Exclude current product from display
    if (this.currentProductId) {
      cards = cards.filter(card => card.id !== this.currentProductId);
    }

    if (cards.length === 0) {
      this.style.display = 'none';
      return;
    }

    // Limit to products_to_show setting
    cards = cards.slice(0, this.maxProducts);

    this.renderSection(cards);
  }

  renderSection(cards) {
    if (cards.length === 0) {
      this.style.display = 'none';
      return;
    }

    // Build products HTML by appending all card HTML
    let productsHTML = '';
    cards.forEach((card, index) => {
      // Replace {index} placeholder with actual index
      let cardHTML = card.html.replace(/id="Slide-[^"]*"/g, `id="Slide-${this.sectionId}-${index + 1}"`);
      cardHTML = cardHTML.replace(/--animation-order:\s*\{index\}/g, `--animation-order: ${index + 1}`);
      productsHTML += cardHTML;
    });

    // Replace placeholders in section template
    let sectionHtml = this.sectionTemplate
      .replace(/{products_html}/g, productsHTML)
      .replace(/{product_count}/g, cards.length);

    this.innerHTML = sectionHtml;
    this.style.display = 'block';

    // Initialize slider
    setTimeout(() => this.initializeSlider(), 100);
  }

  initializeSlider() {
    const sliderComponent = this.querySelector('slider-component');
    if (sliderComponent) {
      setTimeout(() => {
        const resizeEvent = new Event('resize');
        window.dispatchEvent(resizeEvent);
        
        if (sliderComponent.resetPages) {
          sliderComponent.resetPages();
        }
      }, 100);
    }
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
